import { DentalHireMenuHelper, Steps as StepsDental } from "../../../../components/dental-hire-menu/dental-hire-menu";
import { ForeignersHealthHireMenuHelper } from "../../../../components/health-foreigners-hire-menu";
import { HealthHireMenuHelper, Steps } from "../../../../components/health-hire-menu/health-hire-menu";
import { SaludPymesHireMenuHelper, StepsSaludPymes } from "../../../../components/salud-pymes-hire-menu";
import { StepsTravel, TravelHireMenuHelper } from "../../../../components/travel-hire-menu";


export const dataProtectionRoutes = [
    {
        path: '/contratacion/nueva/salud/proteccion-datos',
        nextStep: HealthHireMenuHelper.getNextStepNavigationPath(Steps.ProteccionDatos),
        previousStep: HealthHireMenuHelper.getPreviousStepNavigationPath(Steps.ProteccionDatos),
        area: 'sendaHealth',
    },
    {
        path: '/contratacion/nueva/health/proteccion-datos',
        nextStep: ForeignersHealthHireMenuHelper.getNextStepNavigationPath(Steps.ProteccionDatos),
        previousStep: ForeignersHealthHireMenuHelper.getPreviousStepNavigationPath(Steps.ProteccionDatos),
        area: 'sendaHealth',
    },
    {
        path: '/contratacion/nueva/dental/proteccion-datos',
        nextStep: DentalHireMenuHelper.getNextStepNavigationPath(StepsDental.ProteccionDatos),
        previousStep: DentalHireMenuHelper.getPreviousStepNavigationPath(StepsDental.ProteccionDatos),
        area: 'sendaDental',
    },
    {
        path: '/contratacion/nueva/salud-pymes/proteccion-datos',
        nextStep: SaludPymesHireMenuHelper.getNextStepNavigationPath(StepsSaludPymes.ProteccionDatos),
        previousStep: SaludPymesHireMenuHelper.getPreviousStepNavigationPath(StepsSaludPymes.ProteccionDatos),
        area: 'sendaHealth',
    },
    {
        path: '/contratacion/nueva/travel/:product/proteccion-datos',
        nextStep: (product: any) => TravelHireMenuHelper.getNextStepNavigationPath(StepsTravel.ProteccionDatos, product.products_internalName),
        previousStep: (product: any) => TravelHireMenuHelper.getPreviousStepNavigationPath(StepsTravel.ProteccionDatos, product.products_internalName),
        area: 'sendaTravel',
    }
];
